export default "__VITE_ASSET__ChnvoKvS__"